// extracted by mini-css-extract-plugin
module.exports = {"weeklyKolContainer":"weekly-kol_weeklyKolContainer__3V7BD","card":"weekly-kol_card__1NJMd","slick-dots":"weekly-kol_slick-dots__2DbG_"};